<div class="timezone-wrapper" ngbDropdown>
  <div class="timezone-label" ngbDropdownToggle [class.disabled]="disabled">
    <svg cfIcon="timezone" [class]="disabled ? 'tw:text-raven-40' : 'tw:text-blue-50'"></svg>
    <cf-text
      size="sm"
      class="mx-2"
      className="text-cut max-1 text-break-all"
      matTooltip="{{ timezone | timezoneName: date }} ({{ getTime({ value: timezone }) }})"
    >
      {{ timezone | timezoneName: date }} ({{ getTime({ value: timezone }) }})
    </cf-text>
    @if (!disabled) {
      <svg cfIcon="chevron_down" size="sm"></svg>
    }
  </div>
  <div ngbDropdownMenu class="timezone-list">
    <header>
      <cf-form-field>
        <svg cf-input-prefix cfIcon="search"></svg>
        <!-- @tolgee-key forms.timezone_select.search_placeholder -->
        <input
          cf-input
          [placeholder]="'forms.timezone_select.search_placeholder' | translate"
          [formControl]="searchControl"
        />
      </cf-form-field>
    </header>
    <section class="hide-scrollbar" #listElementWrapper>
      @for (group of timezoneList; track $index) {
        <div class="timezone-item">
          <div class="group">
            <cf-text size="sm" weight="600">{{ group.groupName }}</cf-text>
          </div>
          @for (item of group.result; track $index) {
            <div
              class="timezone-items"
              [id]="item.value"
              [class.active]="timezone === item.value"
              (click)="onModelChange(item)"
            >
              <cf-text size="sm" color="grey-70">
                <span [innerHTML]="item.value | timezoneName: date | highlightSearch: searchControl.value"></span>
                -
                <span [innerHTML]="item.locations | highlightSearch: searchControl.value"></span>
                <span class="text-nowrap"> • {{ getTime(item) }} </span>
              </cf-text>
            </div>
          }
        </div>
      } @empty {
        <div class="mx-3 mb-3">
          <cf-text size="sm" weight="500">{{ "forms.timezone_select.no_items_found" | translate }}</cf-text>
        </div>
      }
    </section>
  </div>
</div>
